// src/app/meter/components/meter-analytics/meter-alert-trend/meter-alert-trend.component.ts

import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { MeterTrendSeries } from '../../../models/meter-analytics.model';

@Component({
    selector: 'app-meter-alert-trend',
    templateUrl: './meter-alert-trend.component.html',
    styleUrls: ['./meter-alert-trend.component.scss'],
})
export class MeterAlertTrendComponent implements OnChanges {
    @Input() data: MeterTrendSeries | null = null;
    @Input() comparePrevious = false;

    chartData: ChartConfiguration<'line'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'line'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 16 } },
        },
        scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true, ticks: { precision: 0 } },
        },
        elements: {
            point: { radius: 3, hoverRadius: 5 },
            line: { tension: 0.3 },
        },
    };

    constructor(private translate: TranslateService) {}

    ngOnChanges(): void {
        if (!this.data || this.data.current.length === 0) return;

        const labels = this.data.current.map((p) => this.formatDate(p.date));
        const datasets: ChartConfiguration<'line'>['data']['datasets'] = [
            {
                label: this.translate.instant('meter.analytics.current_period'),
                data: this.data.current.map((p) => p.value),
                borderColor: '#ef4444',
                backgroundColor: '#ef444420',
                pointBackgroundColor: '#ef4444',
                pointBorderColor: '#ef4444',
                fill: true,
            },
        ];

        if (this.comparePrevious && this.data.previous && this.data.previous.length > 0) {
            datasets.push({
                label: this.translate.instant('meter.analytics.previous_period'),
                data: this.data.previous.map((p) => p.value),
                borderColor: '#d1d5db',
                backgroundColor: 'transparent',
                pointBackgroundColor: '#d1d5db',
                pointBorderColor: '#d1d5db',
                borderDash: [5, 5],
                fill: false,
            });
        }

        this.chartData = { labels, datasets };
    }

    private formatDate(dateStr: string): string {
        if (dateStr.includes('W')) {
            return dateStr;
        }
        const date = new Date(dateStr + 'T00:00:00');
        return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    }
}
